<template>
<div>
<center><h2>INTERÉS</h2></center>
<div :class="{ showNivel : showNiv }">
  <div class="inputControl" >
            <label for="nivelSelected">Nivel: <span>*</span></label>
            <select  name="nivelAlumno" id="nivelAlumno" v-model="nivelSelected"  v-on:change="getCarrera"  style="border-radius:6px;border: solid 1px #5eabe0; background-color:white;padding:10px 16px; width:100%;font-size:16px;color:#505050">
            <option v-for="nv in nivelAlumno" v-bind:key="nv.id" v-bind:value="nv.id">
               {{ nv.name }}
            </option>
            </select>
          </div>
</div>
        
     

  
          <div class="inputControl">
                    <label  for="Carrera">Carrera: <span>*</span></label>
                    <select name="Carrera" id="Carrera" v-model="Carrera" v-on:change="defineModalidad"  style="border-radius:6px;border: solid 1px #5eabe0; background-color:white;padding:10px 16px; width:100%;font-size:16px;color:#505050">
                    <option v-for="cr in carrera" v-bind:key="cr.id" v-bind:value="{IdCarrera: cr.id,Carrera:cr.name}">{{ cr.name }}</option>
            </select>

          </div> 
   
          <div class="inputControl" style="display:none" hidden="true">
                         <label for="Modalidad">Modalidad: <span>*</span></label>
                         <select name="modalidadAlumno" id="modalidadAlumno" v-model="modalidadAlumno" v-on:change="defineCampus" style="border-radius:6px;border: solid 1px #5eabe0; background-color:white;padding:10px 16px; width:100%;font-size:16px;color:#505050">
                         <option v-for="md in modalidad" v-bind:key="md.id" v-bind:value="{GUIDModalidad:md.id,Modalidad:md.name}">{{ md.name }}</option>
                         </select>
          </div>
     
         <div class="inputControl" hidden="true" style="display:none">
                    <label for="Ciclo">Ciclo: <span>*</span></label>
                    <select name="cicloAlumno" id="cicloAlumno" v-model="cicloAlumno" style="border-radius:6px;border: solid 1px #5eabe0; background-color:white;padding:10px 16px; width:80%;font-size:16px;color:#505050">
                    <option v-for="cl in ciclo" v-bind:key="cl.id" v-bind:value="{GUIDCiclo:cl.cicloid,Ciclo:cl.cicloidname,Ciclod:cl.cicloidcod}">{{ cl.cicloidname }}</option>
                   </select>
          </div>  

          <div class="inputControl">
                    <label for="Campus">Campus de interés: <span>*</span></label>
                    <select name="campusAlumno" id="campusAlumno" v-model="campusAlumno" v-on:change="defineCiclo" style="border-radius:6px;border: solid 1px #5eabe0; background-color:white;padding:10px 16px; width:100%;font-size:16px;color:#505050">
                    <option v-for="cm in campus" v-bind:key="cm.id" v-bind:value="{GUIDCampus: cm.id,Campus:cm.name}">{{ cm.name }}</option>
                  </select>
          </div> 
    

  
               
</div>
</template>
<style scoped>
.showNivel {
   display: none;
}
.lblname{
    color: #b11026;
}
.spannal {
   display: none;
}
.bodernamenal{
   border:1px solid #b11026;
}
.spanapal {
   display: none;
}
.boderapnal{
   border:1px solid #b11026;
}
.spanamal {
   display: none;
}
.boderamnal{
    border:1px solid #b11026;
}
.spantlal {
   display: none;
}
.boderatlal{
    border:1px solid #b11026;
}
.spantlcal {
   display: none;
}
.boderatlcal{
   border:1px solid #b11026;
}
.spancoal {
   display: none;
}
.boderacoal{
    border:1px solid #b11026;
    
}
.cardForm {

  border-radius: 6px;
  box-shadow: 0 11px 24px 0 #b0d3eb;
  border: solid 1px #5eabe0;
  background-color: white;
  border-top: solid 8px #0d6eba;
  padding: 24px;
  width: 40%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 45px;
  
  
  }
  @media only screen and (max-width: 880px) {
      .cardForm {
        width: 80%;
      }
  }

.inputControl {
  position: relative;
   margin-top: 30px;
    display: flex;
}
label {
    color: #0d6eba;
    background: white;
    font-size: 14px;
    font-weight: bold;
    position: absolute;
    top: -9px;
    left: 9px;
    padding: 0 8px;
  }

  input {
    border-radius: 6px;
    border: solid 1px #5eabe0;
    background-color: white;
    padding: 10px 16px;
    padding-right: 35px;
    width: 100%;
    font-size: 16px;
    color:  #505050;
  }

   button {
    width: 100%;
    margin-top: 20px;
    text-align: center;
  }

   h2 {
      margin-top: 5px;
      margin-bottom: 25px;
      color:#0d6eba;
      font-weight:700;
      font-size:24px;
    }
    .cmp-button{
        appearance:none;
        border-radius: 3px;
        cursor:pointer;
        font-size:18px;
        padding:9pt 14px 14px;
        text-align:center;
        font-weight:500;
        background-color:#f68b1f;
        border: 1px solid #f68b1f;
        color:#003053!important;
        transition:background-color .4s ease-out,color .3s ease-out,border .4s ease-out;
    }
</style>
<script>
import axios from "axios";
export default {
props:['tpsch'],
name: 'DatosgeneralesInteres',  
mounted() {
    this.getNivel();
    this.getTypesch();
    this.getModalidad();
    this.getCampus();
    this.getCiclo();
           
    },
watch: {
     campusAlumno: function() {
      // Emit this information to the parents component
      this.$emit("datainteres", {nivel:this.nivelAlumno.Nivel,idnivel:this.nivelAlumno.GUIDNivelInteres,
      carrera:this.Carrera.Carrera,idcarrera:this.Carrera.IdCarrera,
      modalidad:this.modalidadname,idmodalidad:this.idmodalidad,
      idcampus:this.campusAlumno.GUIDCampus,campus:this.campusAlumno.Campus,
      ciclo:this.cicloAlumno.Ciclo,idciclo:this.cicloAlumno.GUIDCiclo,ciclod:this.cicloAlumno.Ciclod
      });
    }
  }, 
data(){
        return {
            url:process.env.VUE_APP_URL,
            urlgeneral:process.env.VUE_APP_URL_GENERAL,
            urlpost:process.env.VUE_APP_URL_POST,
            showNiv: true,
            nivel: '',
            carrera: '',
            modalidad: '',
            idmodalidad: '',
            modalidadname: '',
            campus: '',
            ciclo: '',
            level: '',
            modal: '',
            campusD:'',
            clc:'',
            nivelSelected: '',
            nivelAlumno: [{
               Nivel:'',
               GUIDNivelInteres:''
            }
            ],
             Carrera:{
               Carrera:'',
               IdCarrera:''
             },
             modalidadAlumno:{
                Modalidad:'',
                GUIDModalidad:''
             },
             campusAlumno:{
                Campus:'',
                GUIDCampus:''
             },
             cicloAlumno:{
                Ciclo:'',
                GUIDCiclo:'',
                Ciclod:''
             }
        };
    },
methods:{
     getTypesch(){
        var urlLevel = this.tpsch;
        console.log("Nivel url "+urlLevel);
        const vm = this;
     axios.get(this.urlgeneral+"/api/nivel-search-interest").then((result) => {
     //console.log("Data de los intereses "+result.data);
     console.log(result.data);
     vm.nivelAlumno = result.data;
     var newArray = vm.nivelAlumno
     const nombresAEliminar = ["DIPLOMADO", "PREPARATORIA" ];
     const nuevoArray = newArray.filter(item => !nombresAEliminar.includes(item.name));
     console.log(nuevoArray);
        if(urlLevel === "PREPARATORIA"){
         console.log("if");
         const elementoPreparatoria = newArray.find(item => item.name === urlLevel);
         console.log(elementoPreparatoria.id);
         vm.nivelSelected = elementoPreparatoria.id;
         vm.showNiv = true;
         this.getCarrera();
        }
        else if(urlLevel === "LICENCIATURA"){
         console.log("ese if");
         const elementolica = newArray.find(item => item.name === urlLevel);
         console.log(elementolica.id);
         console.log(elementolica);
         vm.nivelSelected = elementolica.id;
         vm.showNiv = false;
         this.getCarrera();
        }
        else{
         console.log("else");
         vm.nivelSelected = '1'
         vm.showNiv = false;
         this.getCarrera();
        }
     }) 
 console.log(vm.nivelSelected);

        },
     defineCarrera(){
        this.Carrera= '';
        //this.modalidadAlumno = null;
        this.campusAlumno = [];
        var valuelevel = this.nivelSelected;
        this.getCarrera(valuelevel);
     },
     defineModalidad(){
        this.modalidadAlumno = '';
        this.campusAlumno = '';
        var grupoCArrera = this.Carrera.IdCarrera;
        var nivel = this.nivelSelected;
        this.getModalidad(grupoCArrera,nivel);
     },
     defineCampus(){
        var grupoCArrera = this.Carrera.IdCarrera;
        var mdl = this.idmodalidad;
        //console.log("modalidad "+mdl);
        this.getCampus(grupoCArrera,mdl);
     },
     defineCiclo(){
        var grupoCArrera = this.Carrera.IdCarrera;
        var mdl = this.modalidadAlumno.GUIDModalidad;
        var cmp = this.campusAlumno.GUIDCampus;
        this.getCiclo(grupoCArrera,mdl,cmp);
        
     },
     getCiclo(grupoCArrera,mdl,cmp) {
      let post = {
        grupo_carrera: grupoCArrera,
        modalidad:mdl,
        campus:cmp
        };  
     const ciclos = this;
     axios.post(this.urlgeneral+"/api/ciclo-search-interest", post).then((result) => {
     //console.log("Data de las ciclos "+result.data.data);
     ciclos.ciclo = result.data.data;
     }) 
     //this.getExtraguidinteres();
    },
    getCampus(grupoCArrera,mdl) {
        let post = {
        grupo_carrera: grupoCArrera,
        modalidad:mdl
        };
     const campusstore = this;
     axios.post(this.urlgeneral+"/api/campus-search-interestpresencial", post).then((result) => {
     //console.log("Data de las campos "+result.data.data);
     campusstore.campus = result.data.data;
     }) 
    },
     getModalidad(grupoCArrera,nivel) {
        let post = {
        grupo_carrera: grupoCArrera,
        nivel:nivel
        };
     const modalidaddes = this;
     axios.post(this.urlgeneral+"/api/modalidad-search-interestpresencial", post).then((result) => {
     //console.log("Data de las modalidades "+result.data.data);
     modalidaddes.modalidad = result.data.data;
     let dataModalidad= result.data.data[0];
     this.idmodalidad = dataModalidad.id;
     this.modalidadname = dataModalidad.name;
     //console.log("id modalidad: "+this.idmodalidad);
     this.defineCampus();
     }) 
    },
    getCarrera() {
       this.modalidadAlumno = "";
        this.campusAlumno = "";
        console.log(this.nivelSelected);
      var valuelevel =  this.nivelSelected;
      console.log("identificador del nivel "+valuelevel);
      let post = {
      linea: valuelevel
      };
     const carreras = this;
     axios.post(this.urlgeneral+"/api/carrera-search-interestpresencial", post).then((result) => {
    // console.log("Data de las carreras "+result.data.data);
     carreras.carrera = result.data.data;
     }) 
    },
    getNivel() {
     const vm = this;
     axios.get(this.urlgeneral+"/api/nivel-search-interest").then((result) => {
     //console.log("Data de los intereses "+result.data);
     console.log(result.data);
     vm.nivelAlumno = result.data;
     var newArray = vm.nivelAlumno
     const nombresAEliminar = ["DIPLOMADO", "PREPARATORIA" ];
     const nuevoArray = newArray.filter(item => !nombresAEliminar.includes(item.name));
     vm.nivelAlumno = nuevoArray;
     }) 
    },
      forceUppercase(e, o, prop) {
      const start = e.target.selectionStart;
      e.target.value = e.target.value.toUpperCase();
      this.$set(o, prop, e.target.value);
      e.target.setSelectionRange(start, start);
    },

     isLetter(e) {
     let char = String.fromCharCode(e.keyCode); // Get the character
     if(/^[A-Za-z\s]+$/.test(char)) return true; // Match with regex 
     else e.preventDefault(); // If not match, don't add to input text
     },
    }
}
</script>